import React, { useEffect } from "react";
import { Box } from "@mui/material";
import HeroSection from "./sections/HeroSection";
import PillarsSection from "./sections/PillarsSection";
import EngagementSection from "./sections/EngagementSection";
import SmartToolsSection from "./sections/SmartToolsSection";
import FeatureTilesSection from "./sections/FeatureTilesSection";
import HealthToolsSection from "./sections/HealthToolsSection";
import VideoReportSection from "./sections/VideoReportSection";

const UserEngagementPage = () => {
  // ── Clarity Event Tracking ──────────────────────────────────────────────
  useEffect(() => {
    const handleClick = (e) => {
      if (typeof window.clarity !== 'function') return;

      const btn = e.target.closest('button');
      if (!btn) return;
      const text = btn.innerText?.trim().toLowerCase() || '';

      // 1. Discover AI Tools (mid-page CTA)
      if (text.includes('discover ai tools')) {
        window.clarity('set', 'cta_clicked', 'eng_discover_ai_tools');
        window.clarity('event', 'eng_discover_ai_tools_clicked');
      }

      // 2. Preview — Follow-up Engines card
      if (text.includes('preview')) {
        const card = btn.closest('div[class*="MuiGrid"], div[class*="css-"], div');
        const heading = card?.querySelector('h2, h3, h4, p, span')?.innerText?.trim().toLowerCase() || '';
        if (heading.includes('follow-up') || heading.includes('follow up')) {
          window.clarity('set', 'eng_preview_clicked', 'followup_engines');
          window.clarity('event', 'eng_followup_engines_preview_clicked');
        }
      }

      // 3. Try Now — Corporate Dashboard card (doc says "Preview" but UI renders "Try Now")
      if (text.includes('try now')) {
        const card = btn.closest('div[class*="MuiGrid"], div[class*="css-"], div');
        const heading = card?.querySelector('h2, h3, h4, p, span')?.innerText?.trim().toLowerCase() || '';
        if (heading.includes('corporate')) {
          window.clarity('set', 'eng_preview_clicked', 'corporate_dashboard');
          window.clarity('event', 'eng_corporate_dashboard_preview_clicked');
        }
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  // ────────────────────────────────────────────────────────────────────────

  // Use SVG from public folder (same pattern as other pages)
  const backgroundSvgPath = "/images/userJourney/assets/job297-ploy-07c-blue-01.svg";

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "transparent",
        backgroundImage: `url(${backgroundSvgPath})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
      }}
    >
      {/* Content wrapper to ensure all sections appear above background */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
        }}
      >
        {/* Hero Section */}
        <HeroSection />

        {/* Pillars Section */}
        <PillarsSection />

        {/* Engagement Section */}
        <EngagementSection />

        {/* Smart Tools Section */}
        <SmartToolsSection />

        {/* Health Tools — Personalised Product Cards */}
        <HealthToolsSection />

        {/* Feature Tiles Section */}
        <FeatureTilesSection />

        {/* Video Report Section */}
        <VideoReportSection />
      </Box>
    </Box>
  );
};

export default UserEngagementPage;

